import React from 'react';

const About = () => (
  <div>&copy; 2016-2023 Copyright Taplause Oy</div>
);

export default About;
